import { responseIsSuccessful } from "../global-helpers";
import { ApiResponseStatus } from "../constants/enums";
import { Contact } from "../models/Contact";
import { Phone } from "../models/Phone";
import { Contract } from "../models/Contract";
import { formatContactObject } from "./api-contacts";

export async function simpleResponse(request) {
  return await request
    .then(res => {
      if (responseIsSuccessful(res)) {
        return ApiResponseStatus.SUCCESS;
      }
      return ApiResponseStatus.ERROR;
    })
    .catch(err => {
      console.log(err);
      return ApiResponseStatus.ERROR;
    });
}

export function formatProjectOrContractObject(object) {
  formatObjectWithNotes(object);
  if (object.primary_contact && object.primary_contact.length) {
    formatContactObject(object.primary_contact[0]);
    object.primary_contact = new Contact(object.primary_contact[0]);
    object.primary_contact_id = object.primary_contact.id;
  }

  if (object.additional_contacts && object.additional_contacts.length) {
    object.additional_contacts = object.additional_contacts.map(c => {
      formatContactObject(c);
      return new Contact(c);
    });
    object.additional_contact_ids = object.additional_contacts.map(c => c.id);
  }

  if (object.contacts && object.contacts.length) {
    object.contacts = object.contacts.map(c => {
      formatContactObject(c);
      return new Contact(c);
    });
  }

  formatPhones(object);

  if (object.contracts && object.contracts.length) {
    object.contracts = object.contracts.map(c => {
      formatProjectOrContractObject(c);
      return new Contract(c);
    });
  }

  if (object.project) {
    object.project_name = object.project.name;
  }
}

export function formatPhones(object) {
  if (object.primary_phone && object.primary_phone.length) {
    object.primary_phone = new Phone(object.primary_phone[0]);
  } else {
    object.primary_phone = undefined;
  }

  if (object.additional_phones && object.additional_phones.length) {
    object.additional_phones = object.additional_phones.map(p => new Phone(p));
  }
}

export function makeFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;

  for (let property in obj) {
    if (
      obj.hasOwnProperty(property) &&
      obj[property] !== null &&
      typeof obj[property] !== "undefined"
    ) {
      if (namespace) {
        formKey = namespace + "[" + property + "]";
      } else {
        formKey = property;
      }

      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (
        typeof obj[property] === "object" &&
        !(obj[property] instanceof File)
      ) {
        makeFormData(obj[property], fd, formKey);
      } else {
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}

export function formatObjectWithNotes(object) {
  if (object.notes && object.notes.length) {
    object.note = object.notes[0];
  } else {
    object.note = null;
  }
}

const asyncIntervals = [];

const runAsyncInterval = async (cb, interval, intervalIndex) => {
  await cb();
  if (asyncIntervals[intervalIndex]) {
    setTimeout(() => runAsyncInterval(cb, interval, intervalIndex), interval);
  }
};

export const setAsyncInterval = (cb, interval) => {
  if (cb && typeof cb === "function") {
    const intervalIndex = asyncIntervals.length;
    asyncIntervals.push(true);
    runAsyncInterval(cb, interval, intervalIndex);
    return intervalIndex;
  } else {
    throw new Error("Callback must be a function");
  }
};

export const clearAsyncInterval = intervalIndex => {
  if (asyncIntervals[intervalIndex]) {
    asyncIntervals[intervalIndex] = false;
  }
};
